export const bool = new Map([
  ['true', true],
  ['false', false],
]);

// currentFacility.summary.facilityRights.
// TODO: need to add following comment to "currentFacility.summery"
// isProEnabled === 'true' && canUpgradeHalo === 'true' as subscriptions
export interface IMenuItem {
  path?: string;
  label: string;
  title: string;
  when?: string[];
  isNew?: boolean;
  icon?: string;
  children?: IMenuItem[];
  expanded?: boolean;
  active?: boolean;
  isMultifacility?: boolean;
  lfFeatureOn?: string | string[];
  lfFeatureOff?: string | string[];
  lfFeatureAnyOn?: string[];
}

export const subscriptionsConfig = new Map([
  [
    'haloTraining',
    {
      label: 'SUBSCRIPTION.HALO.TRAINING',
      title: 'Training Classes',
      when: ['trainingMenu'],
      isNew: false,
      icon: 'Image_SubscribedMenu_HaloTraining.png',
      children: [],
    },
  ],
  [
    'haloTraining.dashboard',
    {
      path: '/training-classes/dashboard',
      label: 'DASHBOARD',
      title: 'Dashboard',
      when: ['trainingPrograms'],
      isNew: false,
    },
  ],
  [
    'haloTraining.training',
    {
      path: '/training-classes/training',
      label: 'TRAINING',
      title: 'Training',
      when: ['trainingPrograms'],
      isNew: false,
      isMultifacility: false,
    },
  ],
  [
    'haloTraining.classes',
    {
      path: '/training-classes/classes',
      label: 'CLASSES',
      title: 'Classes',
      when: ['trainingClasses'],
      isNew: false,
    },
  ],
  [
    'haloTraining.members.manage',
    {
      path: '/members/manage/list',
      label: 'MANAGE',
      title: 'Manage',
      when: ['membersManage'],
      isNew: false,
    },
  ],
  [
    'haloTraining.members.retention',
    {
      path: '/members/retention',
      label: 'RETAIN',
      title: 'Retain',
      when: ['membersRetention'],
      isNew: false,
    },
  ],
  [
    'haloTraining.members.promote',
    {
      path: '/members/promote/massEmails',
      label: 'PROMOTE',
      title: 'Promote',
      when: ['membersPromote'],
      isNew: false,
    },
  ],
  [
    'haloTraining.members.members_challenges',
    {
      path: '/members/membersChallenges',
      label: 'CHALLENGES',
      title: 'Challenges',
      when: ['membersChallenges'],
      isNew: false,
    },
  ],

  [
    'digital_coach',
    {
      label: 'SUBSCRIPTION.DIGITAL.LF.COACH',
      title: 'digital_coach',
      when: ['digitalCoach'],
      icon: 'Image_SubscribedMenu_DigitalCoach.png',
      children: [],
    },
  ],
  [
    'digital_coach.workout_builder',
    {
      path: '/digital_coach/workout_builder',
      label: 'SUBSCRIPTION.DIGITAL.COACH.WORKOUT.BUILDER',
      title: 'digital_coach',
      when: ['digitalCoach'],
    },
  ],
  [
    'digital_coach.studio_controller',
    {
      path: '/digital_coach/studio_controller',
      label: 'SUBSCRIPTION.DIGITAL.COACH.STUDIO.CONTROLLER',
      title: 'digital_coach',
      when: ['digitalCoach'],
    },
  ],
  [
    'content_management',
    {
      path: 'content_management',
      label: 'SUBSCRIPTION.SMART.STRENGTH',
      title: 'content_management',
      when: ['connectedStrength'],
      isNew: false,
      icon: 'Image_SubscribedMenu_ConnectedStrength.png',
    },
  ],
  [
    'subscriptions',
    {
      path: 'purchasePlan',
      label: 'SUBSCRIPTIONS',
      title: 'Subscriptions',
      when: ['subscriptions'],
      isNew: true,
      icon: 'icon-s-shop',
    },
  ],
]);

export const menuConfig = new Map([
  [
    'dashboard',
    {
      path: '/dashboard',
      label: 'DASHBOARD',
      title: 'Dashboard',
      when: ['home'],
      isNew: false,
      icon: 'icon-s-home',
    },
  ],
  [
    'facility',
    {
      label: 'FP.USERPROFILE.LBL.LOCATION',
      title: 'Facility',
      when: ['facility'],
      isNew: false,
      icon: 'icon-s-facility',
      children: [],
    },
  ],
  [
    'facility.manage',
    {
      path: '/facility/manage',
      label: 'MANAGE.FACILITIES',
      title: 'Manage',
      when: ['facility'],
    },
  ],
  [
    'facility.equipment',
    {
      path: '/facility/equipment',
      label: 'EQUIPMENT',
      title: 'Equipment',
      when: ['facility'],
      isNew: false,
    },
  ],
  [
    'facility.staff',
    {
      path: '/facility/staff',
      label: 'STAFF',
      title: 'Staff',
      when: ['facilityStaff'],
      isNew: false,
    },
  ],
  [
    'facility.branding',
    {
      path: '/facility/branding',
      label: 'BRANDING',
      title: 'Branding',
      when: ['branding'],
      isNew: false,
      lfFeatureOn: 'branding-page',
    },
  ],
  [
    'facility.rfid',
    {
      path: '/facility/rfid',
      label: 'RFID.MEMBERS',
      title: 'RFID Members',
      when: ['facility'],
      isNew: false,
      lfFeatureOn: 'rfid-members',
    },
  ],
  [
    'equipment_settings',
    {
      label: 'MENU.EQUIPSETTING',
      title: '',
      when: ['customize'],
      isNew: false,
      icon: 'icon-s-settings',
      children: [],
    },
  ],
  [
    'equipment_settings.attract_screen',
    {
      path: '/equipmentSettings/attractscreen',
      label: 'ATTRACT.SCREENS',
      title: 'Attract Screens',
      when: ['attractScreen'],
      isNew: false,
    },
  ],
  [
    'equipment_settings.announcement',
    {
      path: '/equipmentSettings/announcement',
      label: 'ANNOUNCEMENTS',
      title: 'Announcements',
      when: ['announcement'],
      isNew: false,
    },
  ],
  [
    'equipment_settings.setting',
    {
      path: '/equipmentSettings/setting',
      label: 'PRODUCT.SETTINGS',
      title: 'Product Settings',
      when: ['productSetting'],
      isNew: false,
    },
  ],
  [
    'equipment_settings.entertainment',
    {
      path: '/equipmentSettings/entertainment/iptv',
      label: 'ENTERTAINMENT',
      title: 'Entertainment',
      when: ['entertainment'],
      isNew: false,
    },
  ],
  [
    'equipment_settings.workout',
    {
      path: '/equipmentSettings/workout',
      label: 'CUSTOM.WORKOUTS',
      title: 'Custom Workouts',
      when: ['customWorkouts'],
      lfFeatureOn: 'custom-workout',
      isNew: false,
    },
  ],
  [
    'equipment_settings.performance_run',
    {
      path: '/equipmentSettings/performancerun',
      label: 'PERFORMANCE.RUN',
      title: 'Performance Run',
      when: ['performanceRun'],
      isNew: false,
    },
  ],
  [
    'equipment_settings.life_fitness_on_demand',
    {
      path: '/equipmentSettings/lfod',
      label: 'LF.ON.DEMAND.CLASSES',
      title: 'LF On Demand',
      when: ['lfodEnabledEquipment'],
      lfFeatureOff: 'se3HD',
      isMultifacility: true,
    },
  ],
  [
    'equipment_settings.health_safety',
    {
      path: '/equipmentSettings/healthSafety',
      label: 'HEALTH.SAFETY',
      title: 'Health and Safety',
      when: ['healthSafety'],
      isNew: false,
    },
  ],
  [
    'content_manager',
    {
      label: 'CONTENT.MANAGER',
      title: '',
      when: ['lfodEnabledEquipment'],
      isNew: true,
      icon: 'icon-s-content-manager',
      lfFeatureAnyOn: ['poseidon-milestone-3', 'se3HD'],
      children: [],
    },
  ],
  [
    'content_manager.enable_equipment',
    {
      path: '/enable_equipment',
      label: 'CONTENT.MANAGER.ENABLE.EQUIPMENT',
      title: 'Enable Equipment',
      when: ['lfodEnabledEquipment'],
      lfFeatureAnyOn: ['poseidon-milestone-3', 'se3HD'],
      isNew: false,
      isMultifacility: true,
    },
  ],
  [
    'content_manager.custom_library',
    {
      path: '/videoLibrary',
      label: 'CONTENT.MANAGER.CUSTOM.LIBRARY',
      title: 'Custom Library',
      when: ['customLibrary'],
      lfFeatureOn: ['poseidon-milestone-3'],
      isNew: false,
      isMultifacility: false,
    },
  ],
  [
    'software',
    {
      label: 'SOFTWARE',
      title: 'Software',
      when: ['software'],
      isNew: false,
      icon: 'icon-s-software',
      children: [],
    },
  ],
  [
    'software.remote_update',
    {
      path: '/software/remoteupdate',
      label: 'REMOTE.UPDATES',
      title: 'Remote update',
      when: ['remoteSoftware'],
      isNew: false,
    },
  ],
  [
    'software.life_scape_update*1',
    {
      path: '/software/lifescapeupdate',
      label: 'INTERACTIVE.TERRAINS',
      title: 'Life-scape update',
      when: ['lifescapeCourse'],
      isWebOnly: true,
      lfFeatureOn: 'se3HD',
    },
  ],
  [
    'software.life_scape_update',
    {
      path: '/software/lifescapeupdate',
      label: 'LIFESCAPE.COURSES',
      title: 'Life-scape update',
      when: ['lifescapeCourse'],
      isWebOnly: true,
      lfFeatureOff: 'se3HD',
    },
  ],
  [
    'software.software_download',
    {
      path: '/software/softwareDownload',
      label: 'DOWNLOAD.SOFTWARE',
      title: 'Software Download',
      when: ['software'],
      isNew: false,
      isWebOnly: true,
    },
  ],
  [
    'stats',
    {
      path: '/stats',
      label: 'MENU.STATS',
      title: '',
      when: ['stats'],
      isNew: false,
      icon: 'icon-s-stats',
    },
  ],
  [
    'service',
    {
      path: '/service',
      label: 'SERVICE',
      title: 'Services',
      when: ['serviceNotice'],
      isNew: false,
      icon: 'icon-s-service',
      lfFeatureOff: 'new-service-page',
    },
  ],
  [
    'service/*',
    {
      path: '/service',
      label: 'SERVICE',
      title: 'Services',
      when: ['serviceNotice'],
      isNew: false,
      icon: 'icon-s-service',
      lfFeatureOn: 'new-service-page',
    },
  ],
  [
    'Manage Feature Flags',
    {
      path: '/manageFeatureFlags',
      label: 'Manage Feature Flags',
      title: 'Manage Feature Flags',
      isNew: false,
      lfFeatureOn: 'feature-flag-admin',
    },
  ],
  [
    'api_docs',
    {
      label: 'API Docs',
      icon: 'icon-s-settings',
      title: '',
      children: [],
      lfFeatureOn: 'api-docs',
    },
  ],
  [
    'api_docs.serviceNotices',
    {
      path: '/api-docs/serviceNotices',
      label: 'Service Notices Swagger',
      title: 'Service Notices Swagger',
      lfFeatureOn: 'api-docs',
    },
  ],
]);
